import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

const t = props => (id, defaultMessage = '', variables = null) => {
  const page = id.split('.')[0];
  if (props.translatedMessages
    && props.translatedMessages[page]
    && props.translatedMessages[page][id]) {
    let translatedMessage = props.translatedMessages[page][id];
    if (variables) {
      for (let key in variables) {
        translatedMessage = translatedMessage.replace(new RegExp(`{${key}}`, 'g'), variables[key]);
      }
    }
    return translatedMessage;
  }

  return defaultMessage;
};

const tRoute = props => (routeUrl) => {
  if (props.lang === props.defaultLang) { //no need to add route's locale
    return routeUrl;
  }
  if (routeUrl.startsWith(props.lang) || routeUrl.startsWith('/' + props.lang)) { //needed locale already provided
    return routeUrl;
  }
  //TODO: add validation for empty routes and convert to string or homepage ?
  return routeUrl.charAt(0) === '/' ? `/${props.lang}${routeUrl}` : `/${props.lang}/${routeUrl}`;
};

export const translator = withHandlers({ t, tRoute });

const mapStateToProps = state => ({
    translatedMessages: state.translations, 
    lang: state.langCode,
    defaultLang: state.defaultLangCode 
  });

const withTranslationProvider = compose(
  connect(mapStateToProps),
  translator
);

export default withTranslationProvider;



// WEBPACK FOOTER //
// ./src/Common/Translations/withTranslationProvider.js